import type { AppViewerTool } from '../components/AppViewer/appViewerTool';
import type { Viewer } from '../components/AppViewer/Viewer';
import type { Quaternion, TransformRT3, Vector3 } from '../core/mathTypes';
import { radianToDegree } from '../core/units';
import type { PerspectiveCamera } from '../types/protocolTypes';
import { computeCameraLookAtFromTransform } from '../viewer/cameraLookAtEx';
import { DEFAULT_CAMERA_FAR, DEFAULT_CAMERA_FOV, DEFAULT_CAMERA_NEAR } from '../viewer/constants';

function setCameraFromTransform(viewer: Viewer, transform: TransformRT3) {
  const lookAt = computeCameraLookAtFromTransform(transform);
  const tool = viewer.tool as unknown as AppViewerTool;
  tool.lookAt(lookAt.origin, lookAt.target);
  // Fire event immediately
  tool._emitCameraChange();
}

export const setCamera = (() => {
  const DDEFAULT_TRANSLATION: Vector3 = { x: 0.0, y: 1.2, z: 3.0 };
  const DEFAULT_ROTATION: Quaternion = { x: 0.0, y: 0.0, z: 0.0, w: 1.0 };

  return (viewer: Viewer, desc: PerspectiveCamera) => {
    const far = desc.far ?? DEFAULT_CAMERA_FAR;
    const fov = desc.fov ?? DEFAULT_CAMERA_FOV;
    const near = desc.near ?? DEFAULT_CAMERA_NEAR;
    const rotation = desc.transform?.rotation ?? DEFAULT_ROTATION;
    const translation = desc.transform?.translation ?? DDEFAULT_TRANSLATION;
    // update transform
    const transform: TransformRT3 = { rotation, translation };
    setCameraFromTransform(viewer, transform);
    // update projection matrix
    const camera = viewer.camera;
    camera.far = far;
    camera.fov = radianToDegree(fov);
    camera.near = near;
    camera.updateProjectionMatrix();
  };
})();
